import React, { createContext, useContext, useEffect, useState } from "react";
import { apiBoss } from "./api";

const BossAuthCtx = createContext(null);

export function BossAuthProvider({ children }) {
  const [boss, setBoss] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tablezy_boss_token");
    if (!token) {
      setLoading(false);
      return;
    }
    apiBoss.get("/boss/me")
      .then(({ data }) => setBoss(data.user))
      .catch(() => localStorage.removeItem("tablezy_boss_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await apiBoss.post("/boss/login", { email, password });
    localStorage.setItem("tablezy_boss_token", data.token);
    setBoss(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tablezy_boss_token");
    setBoss(null);
  };

  return (
    <BossAuthCtx.Provider value={{ boss, loading, login, logout }}>
      {children}
    </BossAuthCtx.Provider>
  );
}

export const useBossAuth = () => useContext(BossAuthCtx);
